import { h, Host, } from "@stencil/core";
import { requiredLabel, formMessageLogic } from "../../common/form";
import { formClasses } from "../../common/classesNames";
export class GxgFormRadioGroup {
    constructor() {
        this.center = false;
        this.disabled = false;
        this.label = undefined;
        this.value = undefined;
        this.row = undefined;
        this.validationMessage = undefined;
        this.required = false;
        this.validationStatus = "indeterminate";
        this.informationMessage = undefined;
    }
    showValidationMessage = false;
    _componentDidLoad = false;
    el;
    /*VALIDATION*/
    formMessageLogic = formMessageLogic;
    /**
     * Emits the value when is changed, and the radio id.
     */
    change;
    /*********************************
    METHODS
    *********************************/
    disabledHandler(newValue) {
        if (newValue === true) {
            this.disableAllRadios();
        }
        else {
            this.enableAllRadios();
        }
    }
    watchValueHandler(newValue) {
        const newCheckedRadio = this.getCheckboxByValue(newValue);
        this.uncheckAll(newCheckedRadio);
        if (this._componentDidLoad) {
            //_componentDidLoad prevents change event being emitted the first time.
            this.change.emit({
                id: newCheckedRadio.radioId,
                value: this.value,
            });
        }
    }
    radioCheckedHandler(radioInfo) {
        this.value = radioInfo.detail.value;
    }
    keyPressedHandler(event) {
        const key = event.detail;
        const currentRadio = event.target;
        let newRadio = null;
        const radiosArray = Array.from(this.el.querySelectorAll("gxg-form-radio:not([disabled])"));
        const currentRadioIndex = radiosArray.findIndex((radio) => {
            return currentRadio === radio;
        });
        if (currentRadioIndex !== -1) {
            if (key === "ArrowDown" || key === "ArrowRight") {
                if (currentRadioIndex + 1 < radiosArray.length) {
                    newRadio = radiosArray[currentRadioIndex + 1];
                }
            }
            else if (key === "ArrowUp" || key === "ArrowLeft") {
                if (currentRadioIndex - 1 < radiosArray.length) {
                    newRadio = radiosArray[currentRadioIndex - 1];
                }
            }
            if (newRadio) {
                newRadio.focus();
                newRadio.checked = true;
                this.value = newRadio.value;
            }
        }
    }
    componentWillLoad() {
        if (this.disabled) {
            this.disableAllRadios();
        }
        this.setValue();
    }
    componentDidLoad() {
        this._componentDidLoad = true;
    }
    renderLabel() {
        if (this.label) {
            return (h("gxg-label", { class: "label" }, this.label, requiredLabel(this)));
        }
    }
    uncheckAll = (checkedRadio) => {
        const enabledRadios = this.getEnabledRadios();
        if (enabledRadios.length) {
            enabledRadios.forEach((radio) => {
                if (checkedRadio !== radio && radio.checked)
                    radio.checked = false;
            });
        }
    };
    setValue = () => {
        const enabledRadios = this.getEnabledRadios();
        let checkedRadio;
        enabledRadios.forEach((radio) => {
            if (!radio.disabled && !checkedRadio) {
                !checkedRadio && radio.checked && (checkedRadio = radio);
            }
        });
        if (this.value && checkedRadio) {
            //verify if they coincide
            if (this.value !== checkedRadio.value) {
                //value then is the checked radio value
                this.value = checkedRadio.value;
            }
        }
        else if (this.value && !checkedRadio) {
            const foundRadio = enabledRadios.find((radio) => {
                return radio.value === this.value;
            });
            if (foundRadio) {
                foundRadio.checked = true;
            }
            else {
                //there is no radio with the provided value. Set first radio checked.
                this.value = enabledRadios[0].value;
                enabledRadios[0].checked = true;
            }
        }
        else if (!this.value && checkedRadio) {
            //Value should be the checked radio value
            this.value = checkedRadio.value;
        }
        else {
            //no value, no checked radio - set the first radio.
            this.value = enabledRadios[0].value;
            enabledRadios[0].checked = true;
        }
    };
    disableAllRadios = () => {
        if (this.disabled) {
            const radios = this.el.querySelectorAll("gxg-form-radio");
            radios.forEach((radio) => {
                radio.disabled = true;
            });
        }
    };
    enableAllRadios = () => {
        if (!this.disabled) {
            const radios = this.el.querySelectorAll("gxg-form-radio");
            radios.forEach((radio) => {
                radio.disabled = false;
                if (radio.value === this.value) {
                    radio.checked = true;
                }
            });
        }
    };
    getEnabledRadios = () => {
        const allRadios = this.el.querySelectorAll("gxg-form-radio");
        const enabledRadios = [];
        allRadios.forEach((radio) => {
            if (!radio.disabled) {
                enabledRadios.push(radio);
            }
        });
        return enabledRadios;
    };
    getCheckboxByValue = (value) => {
        const enabledRadios = this.getEnabledRadios();
        let radio;
        if (enabledRadios.length) {
            radio = enabledRadios.find((radio) => {
                return radio.value === value;
            });
        }
        return radio;
    };
    render() {
        return (h(Host, { class: {
                "gxg-form-radio-group": true,
                "gxg-form-radio-group--row": this.row,
                "gxg-form-radio-group--center": this.center && this.row,
                [formClasses["VALIDATION_INDETERMINATE_CLASS"]]: this.validationStatus === "indeterminate",
                [formClasses["VALIDATION_WARNING_CLASS"]]: this.validationStatus === "warning",
                [formClasses["VALIDATION_ERROR_CLASS"]]: this.validationStatus === "error",
                [formClasses["VALIDATION_SUCCESS_CLASS"]]: this.validationStatus === "success",
            } }, this.renderLabel(), h("div", { class: "radios-wrapper" }, h("slot", null)), formMessageLogic(this)));
    }
    static get is() { return "gxg-form-radio-group"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["form-radio-group.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["form-radio-group.css"]
        };
    }
    static get properties() {
        return {
            "center": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Centers the radios if 'row' is true"
                },
                "attribute": "center",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the input disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The radio group label"
                },
                "attribute": "label",
                "reflect": false
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The radio group checked radio value"
                },
                "attribute": "value",
                "reflect": true
            },
            "row": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the radios be displayed with flex \"row\", instead of flex \"column\""
                },
                "attribute": "row",
                "reflect": false
            },
            "validationMessage": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The required message if this input is required and no value is provided (optional). If this is not provided, the default browser required message will show up"
                },
                "attribute": "validation-message",
                "reflect": false
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Make the radio-buttons required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "validationStatus": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "ValidationStatus",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "ValidationStatus": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::ValidationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The validation status"
                },
                "attribute": "validation-status",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            },
            "informationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An informative message to help the user filling the information"
                },
                "attribute": "information-message",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "change",
                "name": "change",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the value when is changed, and the radio id."
                },
                "complexType": {
                    "original": "RadioData",
                    "resolved": "{ value: string; id?: string; }",
                    "references": {
                        "RadioData": {
                            "location": "import",
                            "path": "../form-radio/form-radio",
                            "id": "src/components/form-radio/form-radio.tsx::RadioData"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "disabled",
                "methodName": "disabledHandler"
            }, {
                "propName": "value",
                "methodName": "watchValueHandler"
            }];
    }
    static get listeners() {
        return [{
                "name": "radioChecked",
                "method": "radioCheckedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "keyPressed",
                "method": "keyPressedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=form-radio-group.js.map
